
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useToast } from '@/hooks/use-toast';
import { promoteUserToAdmin } from '@/lib/supabase/profilesApi';
import { Shield } from 'lucide-react';

const AdminPromotion = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handlePromote = async () => {
    if (!email) {
      toast({
        title: 'Error',
        description: 'Please enter an email address',
        variant: 'destructive'
      });
      return;
    }

    setIsLoading(true);
    try {
      const result = await promoteUserToAdmin(email);
      
      if (result.success) {
        toast({
          title: 'Success',
          description: result.message || `User ${email} has been promoted to admin`,
        });
        setEmail('');
      } else {
        toast({
          title: 'Error',
          description: result.error || 'Failed to promote user to admin',
          variant: 'destructive'
        });
      }
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Failed to promote user to admin',
        variant: 'destructive'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-fraudeye-primary p-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <Shield className="h-12 w-12 text-fraudeye-accent" />
          </div>
          <h2 className="text-3xl font-extrabold text-gray-900 dark:text-white">
            Promote to Admin
          </h2>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            Enter the email of the user you want to promote
          </p>
        </div>
        <div className="space-y-4">
          <Input
            type="email"
            placeholder="user@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button 
            onClick={handlePromote} 
            disabled={isLoading}
            className="w-full bg-fraudeye-accent hover:bg-fraudeye-highlight"
          >
            {isLoading ? 'Promoting...' : 'Promote to Admin'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminPromotion;
